var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "b-container",
        { staticClass: "px-0", attrs: { fluid: "" } },
        [
          _c(
            "b-row",
            { attrs: { "no-gutters": "" } },
            [
              _c(
                "b-col",
                { attrs: { cols: "12" } },
                [
                  _c(
                    "b-alert",
                    {
                      staticClass: "mb-3",
                      attrs: { show: _vm.errorSaving, variant: "danger" },
                    },
                    [
                      _vm._v(
                        "\n          An error occurred while attempting to save this catalogue, please try again.\n        "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-alert",
                    {
                      staticClass: "mb-3",
                      attrs: { show: _vm.formUpdated, variant: "info" },
                    },
                    [
                      _vm._v(
                        "\n          There are currently unsaved changes for this catalogue.\n        "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "general-settings mb-5" },
                    [
                      _c("h4", { staticClass: "mb-3" }, [
                        _vm._v("\n            General Settings\n          "),
                      ]),
                      _vm._v(" "),
                      _c(
                        "b-form-group",
                        {
                          attrs: {
                            id: "input-group-2",
                            label: "Catalogue Name:",
                            "label-for": "input-2",
                          },
                        },
                        [
                          _c("b-form-input", {
                            attrs: {
                              id: "input-2",
                              placeholder: "Enter name",
                              required: "",
                            },
                            model: {
                              value: _vm.form.name,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "name", $$v)
                              },
                              expression: "form.name",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-form-group",
                        {
                          attrs: {
                            id: "input-group-2",
                            label: "Catalogue Description:",
                            "label-for": "input-2",
                          },
                        },
                        [
                          _c("b-form-textarea", {
                            attrs: {
                              id: "input-2",
                              placeholder: "Product Catalogue description",
                              required: "",
                            },
                            model: {
                              value: _vm.form.description,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "description", $$v)
                              },
                              expression: "form.description",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-form-group",
                        {
                          attrs: {
                            id: "input-group-2",
                            label: "Published:",
                            "label-for": "input-2",
                          },
                        },
                        [
                          _c("swoggle", {
                            attrs: { "label-on": "Yes", "label-off": "No" },
                            model: {
                              value: _vm.form.active,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "active", $$v)
                              },
                              expression: "form.active",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("h4", { staticClass: "mb-3" }, [
                    _vm._v("\n          Product Settings\n        "),
                  ]),
                  _vm._v(" "),
                  _c(
                    "b-form-group",
                    {
                      staticClass: "mb-5",
                      attrs: {
                        id: "input-group-3",
                        label: "Catalogue Products:",
                        "label-for": "input-3",
                      },
                    },
                    [
                      _vm.availableProducts.length > 0
                        ? _c("typeahead-field-edit", {
                            attrs: {
                              options: _vm.availableProducts,
                              label: "Add Product",
                              value: "",
                            },
                            on: { input: _vm.addProduct },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.form.products.length
                    ? _c(
                        "b-table-simple",
                        [
                          _c(
                            "b-thead",
                            [
                              _c("b-th", [_vm._v("Order")]),
                              _vm._v(" "),
                              _c("b-th", [_vm._v("SKU")]),
                              _vm._v(" "),
                              _c("b-th", [_vm._v("Title")]),
                              _vm._v(" "),
                              _c("b-th", { staticClass: "text-right" }, [
                                _vm._v("\n              Actions\n            "),
                              ]),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "draggable",
                            {
                              class: {
                                [`cursor-grabbing`]: _vm.dragging === true,
                              },
                              attrs: {
                                group: "products",
                                handle: ".handle",
                                tag: "tbody",
                              },
                              on: {
                                end: function ($event) {
                                  _vm.dragging = false
                                },
                                start: function ($event) {
                                  _vm.dragging = true
                                },
                              },
                              model: {
                                value: _vm.form.products,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "products", $$v)
                                },
                                expression: "form.products",
                              },
                            },
                            _vm._l(_vm.form.products, function (productID) {
                              return _c("catalogue-product-data", {
                                key: productID,
                                attrs: { id: productID },
                                on: { delete: _vm.deleteProduct },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "b-button",
                    {
                      staticClass: "mr-auto float-right",
                      attrs: {
                        disabled: _vm.submitNotAllowed || _vm.saving,
                        variant: "primary",
                      },
                      on: { click: _vm.onSubmit },
                    },
                    [
                      _vm.saving
                        ? [
                            _c("b-spinner", {
                              attrs: { small: "", type: "grow" },
                            }),
                            _vm._v("\n            Saving...\n          "),
                          ]
                        : [_vm._v("\n            Save Catalogue\n          ")],
                    ],
                    2
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }